import { useMemo } from 'react';
import { selectBridgeSlice } from '../../redux/slices/bridgeSlice';

import { calcTaxAmount } from '../../utils/calc';
import useAppSelector from '../useAppSelector';
import useTokensInitialData from '../queries/useTokenInitialData';

const useTax = () => {
  const tokensInitialData = useTokensInitialData();
  const { fromChainToken, tokenTransferAmount } =
    useAppSelector(selectBridgeSlice);

  const chainTransferTax = useMemo(() => {
    if (!tokensInitialData || !fromChainToken) return null;

    return (
      tokensInitialData?.find(
        (token) => token.symbol === fromChainToken.symbol,
      ) ?? null
    );
  }, [tokensInitialData, fromChainToken]);

  const taxAmount = useMemo(
    () =>
      fromChainToken
        ? calcTaxAmount({
            chainTransferTax,
            token: fromChainToken,
            transferAmount: tokenTransferAmount,
          })
        : ``,
    [chainTransferTax, fromChainToken, tokenTransferAmount],
  );

  return { taxRange: Number(chainTransferTax?.tax), taxAmount };
};

export default useTax;
